// extracted by mini-css-extract-plugin
module.exports = {"categories":"MediaCategories_categories__6LVt2"};